export const validateCategory = (data) => {
    const errors = {};
    if (!data.name.trim()) {
      errors.name = 'Name is required';
    } else if (data.name.length > 25) {
      errors.name = 'Name cannot exceed 25 characters';
    }
    if (data.is_default !== undefined && typeof data.is_default !== 'boolean') {
      errors.is_default = 'is_default must be true or false';
    }
    return errors;
  };